import { render, staticRenderFns } from "./SupportingDocumentationStep.vue?vue&type=template&id=117a9622"
import script from "./SupportingDocumentationStep.vue?vue&type=script&lang=js"
export * from "./SupportingDocumentationStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports